import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ContactForm from '../components/ContactForm';
import ProductCard from '../components/ProductCard';
import { getProduct, getRelatedProducts, getProductVariations } from '../api/woocommerce';

const IMG_CONTACT_BG = '/sfondo-form.jpg';

export default function ProdottoPage() {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [related, setRelated] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeImg, setActiveImg] = useState(0);
  const [variations, setVariations] = useState([]);
  const [selectedAttrs, setSelectedAttrs] = useState({});

  useEffect(() => {
    window.scrollTo(0, 0);
    setLoading(true);
    setVariations([]);
    setSelectedAttrs({});
    getProduct(id).then(async p => {
      setProduct(p);
      setActiveImg(0);
      if (p.type === 'variable') {
        const vars = await getProductVariations(p.id);
        setVariations(vars);
        if (vars.length > 0) {
          const init = {};
          vars[0].attributes.forEach(a => { init[a.name] = a.option; });
          setSelectedAttrs(init);
        }
      }
      if (p.related_ids?.length > 0) {
        const rel = await getRelatedProducts(p.related_ids.slice(0, 4));
        setRelated(rel);
      }
    }).catch(console.error).finally(() => setLoading(false));
  }, [id]);

  if (loading) return <div style={{background:'#000',minHeight:'100vh'}}><Navbar /><div style={{textAlign:'center',padding:'120px 20px',fontFamily:"'Alumni Sans',sans-serif",fontSize:26,color:'rgba(255,255,255,0.4)'}}>Caricamento...</div></div>;
  if (!product) return <div style={{background:'#000',minHeight:'100vh'}}><Navbar /><div style={{textAlign:'center',padding:'120px 20px',fontFamily:"'Alumni Sans',sans-serif",fontSize:26,color:'rgba(255,255,255,0.4)'}}>Prodotto non trovato</div><Footer /></div>;

  const activeVariation = variations.find(v =>
    v.attributes.every(a => selectedAttrs[a.name] === a.option)
  ) || null;

  const displayImg = (activeVariation?.image?.id > 0)
    ? activeVariation.image.src
    : product.images?.[activeImg]?.src;

  const displayPrice = activeVariation?.price || product.price;

  const category = product.categories?.[0]?.name || 'Prodotto';
  const cleanDesc = product.description || product.short_description || '';

  const variationAttrs = product.attributes?.filter(a => a.variation) || [];
  const staticAttrs = product.type === 'variable'
    ? product.attributes?.filter(a => !a.variation) || []
    : product.attributes || [];

  return (
    <>
      <style>{`
        .prod-page { background: #000; min-height: 100vh; }
        .prod-breadcrumb { padding: 8px 138px; background: #000; font-size: 13px; color: rgba(255,255,255,0.5); font-family: 'Roboto',sans-serif; }
        .prod-detail { background: #000; display: grid; grid-template-columns: 1fr 1fr; min-height: 80vh; padding-top: 110px; }
        .prod-img-wrap { display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 60px 40px; position: relative; }
        .prod-main-img { max-width: 85%; max-height: 600px; object-fit: contain; filter: drop-shadow(0 0 60px rgba(215,25,33,0.12)); }
        .prod-thumbs { display: flex; gap: 8px; margin-top: 20px; flex-wrap: wrap; justify-content: center; }
        .prod-thumb { width: 56px; height: 56px; object-fit: cover; cursor: pointer; border: 2px solid transparent; opacity: 0.5; transition: all 0.2s; }
        .prod-thumb.active { border-color: #d71921; opacity: 1; }
        .prod-info { padding: 80px 80px 80px 40px; display: flex; flex-direction: column; justify-content: center; position: relative; border-left: 1px solid rgba(255,255,255,0.1); }
        .prod-category { font-family: 'Alumni Sans',sans-serif; font-weight: 500; font-size: 22px; color: #d71921; margin-bottom: 8px; }
        .prod-name { font-family: 'Alumni Sans',sans-serif; font-weight: 500; font-size: 64px; line-height: 58px; color: #fff; margin-bottom: 20px; }
        .prod-desc { font-family: 'Roboto',sans-serif; font-weight: 300; font-size: 15px; color: rgba(255,255,255,0.8); line-height: 1.7; margin-bottom: 28px; }
        .prod-attribs { background: #181818; display: flex; flex-wrap: wrap; margin-bottom: 24px; }
        .prod-attrib { font-family: 'Alumni Sans',sans-serif; font-weight: 500; font-size: 22px; color: #fff; padding: 16px 28px; border-right: 1px solid rgba(255,255,255,0.1); }
        .prod-price { font-family: 'Alumni Sans',sans-serif; font-size: 28px; color: #d71921; margin-bottom: 16px; }
        .prod-line { background: #000; height: 30px; }
        .prod-related { background: #000; padding: 60px 138px; }
        .prod-related-title { font-family: 'Alumni Sans',sans-serif; font-weight: 500; font-size: 56px; color: #fff; text-align: center; margin-bottom: 36px; }
        .prod-related-grid { display: grid; grid-template-columns: repeat(4,1fr); background: #000; gap: 12px; }
        .prod-variants { margin-bottom: 24px; }
        .prod-variant-group { margin-bottom: 18px; }
        .prod-variant-label { font-family: 'Alumni Sans',sans-serif; font-weight: 500; font-size: 18px; color: rgba(255,255,255,0.6); margin-bottom: 10px; text-transform: uppercase; letter-spacing: 0.05em; }
        .prod-variant-options { display: flex; flex-wrap: wrap; gap: 8px; }
        .prod-variant-btn { font-family: 'Alumni Sans',sans-serif; font-weight: 500; font-size: 18px; color: #fff; background: transparent; border: 1px solid rgba(255,255,255,0.3); padding: 8px 20px; cursor: pointer; transition: all 0.2s; }
        .prod-variant-btn:hover { border-color: #d71921; color: #d71921; }
        .prod-variant-btn.active { background: #d71921; border-color: #d71921; color: #fff; }

        @media (max-width: 1100px) {
          .prod-breadcrumb { padding: 8px 60px; }
          .prod-related { padding: 50px 60px; }
          .prod-related-grid { grid-template-columns: repeat(3,1fr); }
        }
        @media (max-width: 900px) {
          .prod-breadcrumb { padding: 8px 20px; }
          .prod-detail { grid-template-columns: 1fr; padding-top: 90px; }
          .prod-img-wrap { padding: 40px 20px 20px; border-left: none; }
          .prod-info { padding: 20px 20px 60px; border-left: none; border-top: 1px solid rgba(255,255,255,0.1); }
          .prod-name { font-size: 48px; line-height: 44px; }
          .prod-related { padding: 40px 20px; }
          .prod-related-grid { grid-template-columns: repeat(2,1fr); }
          .prod-related-title { font-size: 40px; }
        }
        @media (max-width: 500px) {
          .prod-name { font-size: 36px; line-height: 34px; }
          .prod-related-grid { grid-template-columns: 1fr 1fr; }
        }
      `}</style>

      <div className="prod-page">
        <Navbar />

        <section className="prod-detail">
          <div className="prod-img-wrap">
            {displayImg && <img src={displayImg} alt={product.name} className="prod-main-img" />}
            {product.images?.length > 1 && (
              <div className="prod-thumbs">
                {product.images.slice(0, 5).map((img, i) => (
                  <img key={i} src={img.src} alt="" className={`prod-thumb${i === activeImg ? ' active' : ''}`} onClick={() => setActiveImg(i)} />
                ))}
              </div>
            )}
          </div>
          <div className="prod-info">
            <p className="prod-category">{category}</p>
            <h1 className="prod-name">{product.name}</h1>
            {cleanDesc && <p className="prod-desc" dangerouslySetInnerHTML={{ __html: cleanDesc }} />}
            {variationAttrs.length > 0 && (
              <div className="prod-variants">
                {variationAttrs.map(attr => (
                  <div key={attr.name} className="prod-variant-group">
                    <p className="prod-variant-label">{attr.name}:</p>
                    <div className="prod-variant-options">
                      {attr.options.map(opt => (
                        <button
                          key={opt}
                          className={`prod-variant-btn${selectedAttrs[attr.name] === opt ? ' active' : ''}`}
                          onClick={() => setSelectedAttrs(prev => ({ ...prev, [attr.name]: opt }))}
                        >
                          {opt}
                        </button>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            )}
            {staticAttrs.length > 0 && (
              <div className="prod-attribs">
                {staticAttrs.map(a => a.options?.map((opt, i) => (
                  <span key={`${a.name}-${i}`} className="prod-attrib">{opt}</span>
                )))}
              </div>
            )}
            {displayPrice && <p className="prod-price">{displayPrice} €</p>}
          </div>
        </section>

        <div className="prod-line" />

        {related.length > 0 && (
          <section className="prod-related">
            <h2 className="prod-related-title">Prodotti correlati</h2>
            <div className="prod-related-grid">
              {related.map(p => <ProductCard key={p.id} product={p} />)}
            </div>
          </section>
        )}

        <ContactForm productName={product.name} bgImage={IMG_CONTACT_BG} />
        <Footer />
      </div>
    </>
  );
}
